'use client'

import { Link } from '@/i18n/navigation'
import MuiLink from '@mui/material/Link'

function CustomLink({ children, ...props }) {
  return (
    <MuiLink
      component={Link}
      scroll={true}
      data-test='RAM'
      underline='always'
      {...props}
    >
      {children}
    </MuiLink>
  )
}

export default CustomLink
